import { useQuery } from "@tanstack/react-query";

import { getOrganizationUsers } from "../../services/users";

const useGetOrganizationUsers = (organizationId: number | null) => {

    const queryFn = async () => {
        return await getOrganizationUsers(organizationId ?? 0);
    };

    return useQuery({
        queryKey: ['users', organizationId],
        queryFn,
        retry: 0,
        enabled: !!organizationId,
    });
};

export default useGetOrganizationUsers;